import type { FaireProductEntity } from "../../entity_types/product";

export const p_xv43jvewmu: FaireProductEntity = {
  token: "p_xv43jvewmu",
  type: "product",
  name: "Moroccan Cone Glassware Small - Green",
  brandToken: "b_6xvu4qtx",
  brandName: "Verve Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/1cbbf47ed611e5865a94728439ea73063808e66331491bf664792147c3bfd946.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/372b543bfa5fd9a4be415e659f667c7b1468af755c7312c872661c059df5cb0f.jpeg",
    "https://cdn.faire.com/fastly/751785b80bc976fad4e02edc95c300a0b5bd5f245dc2d537755dc1d35728819d.jpeg",
    "https://cdn.faire.com/fastly/84c22145cc75956a05179ff15283753c226e0c82bfbdeeae04480afea1c02438.jpeg",
    "https://cdn.faire.com/fastly/c00d7f9850c9abdf48bb1054946f07750ecee6ced09f47722f1ddd75dfdb2117.jpeg",
    "https://cdn.faire.com/fastly/850108597c8dccfd94a9869ce629571291e02b8e12e11f41cc55c1eebd4e312f.jpeg",
    "https://cdn.faire.com/fastly/8eadbcbaf75ea0a9147cc380129ffd099126b319dcf76f54a028893de2a1fe91.jpeg",
    "https://cdn.faire.com/fastly/a34b8b95f0a48e73301dbffdc785a329a63d496ae475559651afd8e886fcadbc.jpeg",
  ],
  priceDollars: 3.75,
  description:
    '**Packaged in sets of 6** - 24 single glasses in a master\nSee separate listings for each color option.\n\nThe sleek and simple design of these hand-blown cone shaped glasses are a testament to the style and skill of the artisans who make them. Used for all types of beverages or as little vases to decorate each table setting, you will enjoy the feel of them in your hand as you toast the joys of the day. \n\nOur Moroccan glassware sets come in four distinct shades of transparent glass (Clear, Amber, Blue & Green). The handblown construction is evident in the bubbles suspended in the glass itself, and the organic forms that the vessels take.\n\nMade from recycled beer and wine bottles, these sets are a second act for glass that would otherwise be sent to landfills. \n\nSmall Cone: bottom diameter 3", top diameter 2.5"  / 3.5" height. Capacity: 8 fl oz\n\nPackaged in sets of 6 in traditional Moroccan gift packaging.',
  tags: [],
  msrpDollars: 7.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-05T16:55:02.994Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
